import React, { useState, useEffect } from "react";
import "./FAQ.css";
import { Accordion } from "react-bootstrap";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Common_Banner from "../common-components/common_banner/Common_Banner";
import Common_Banner_2 from "../common-components/common_banner_2/Common_Banner_2";
import { FaqId, FaqsCategory, Faqs } from "../../utils/apis/faq/Faq";

const FAQ = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "FREQUENTLY ASKED QUESTIONS", link: "", isActive: true },
  ];

  const [activeKey, setActiveKey] = useState("0");

  const [faqData, setFaqData] = useState([]);

  const getFaqs = async () => {
    try {
      const res = await Faqs();

      if (res?.success && Array.isArray(res?.data)) {
        setFaqData(res.data);
      } else {
        setFaqData([]);
      }
    } catch (error) {
      console.error("Error fetching FAQs:", error);
      setFaqData([]);
    }
  };

  useEffect(() => {
    getFaqs();
  }, []);

  const groupedFaqs = faqData.reduce((groups, faq) => {
    const categoryId = faq?.FAQ_Category?.id;

    if (!categoryId) {
      return groups;
    }

    if (!groups[categoryId]) {
      groups[categoryId] = {
        id: categoryId,
        title: faq?.FAQ_Category?.name || "FAQs",
        faqs: [],
      };
    }

    groups[categoryId].faqs.push(faq);

    return groups;
  }, {});

  const faqSections = Object.values(groupedFaqs);

  const faqData1 = [
    {
      title: "Products",
      faqs: [
        {
          question: "What types of agricultural products do you offer?",
          answer:
            "We offer a wide range of agricultural products, including high-quality seeds, fertilizers, pesticides, bio-fertilizers, and plant growth enhancers to support healthy crop production.",
        },
        {
          question: "How do I choose the right product for my crop?",
          answer:
            "Our experts can help you select the most suitable products based on your crop type, soil condition, and farming requirements.",
        },
      ],
    },
    {
      title: "Dosage",
      faqs: [
        {
          question: "How do I know the correct dosage for a product?",
          answer:
            "The recommended dosage is mentioned on the product label. You can also consult our agricultural experts for crop-specific guidance.",
        },
        {
          question: "Can I increase the dosage for better results?",
          answer:
            "No. Always use the recommended dosage. Overuse may affect crop health and reduce product effectiveness.",
        },
      ],
    },
    {
      title: "Dealer Policy",
      faqs: [
        {
          question: "How can I become an authorized dealer?",
          answer:
            "You can contact our sales team or submit a dealer inquiry form on our website. Our team will guide you through the registration process.",
        },
        {
          question: "What benefits do authorized dealers receive?",
          answer:
            "Authorized dealers enjoy competitive pricing, promotional support, product training, and dedicated customer assistance.",
        },
      ],
    },
    {
      title: "Shipping",
      faqs: [
        {
          question: "How long does it take to deliver an order?",
          answer:
            "Orders are generally delivered within 3–7 business days depending on your location.",
        },
        {
          question: "Do you provide shipping across India?",
          answer:
            "Yes, we provide reliable shipping services across most regions of India.",
        },
      ],
    },
    {
      title: "Payments",
      faqs: [
        {
          question: "What payment methods do you accept?",
          answer:
            "We accept UPI, debit cards, credit cards, net banking, and other secure online payment methods.",
        },
        {
          question: "Is it safe to make payments on your website?",
          answer:
            "Yes, all transactions are processed through secure payment gateways to ensure complete payment security.",
        },
      ],
    },
  ];

  return (
    <section className="FAQ">
      {/* <Common_Banner imgSrc={"/assets/images/faq/banner.png"} /> */}
      <Common_Banner_2
        imgSrc="/assets/images/home/commng-soon/agri_bg.png"
        title_text="FAQs"
      />

      <div className="container">
        {/* <div className='top_div'>
                    <Breadcrumb_comp breadcrumbs={breadcrumbs} />
                </div> */}

        <div className="faq_div">
          <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}
          >
            {faqSections?.map((section, sectionIndex) => (
              <div key={section?.id} className="faq_category">
                <h3 className="faq_main_heading">{section.title}</h3>

                {section.faqs.map((item) => {
                  const eventKey = `${section.id}-${item.id}`;

                  return (
                    <Accordion.Item eventKey={eventKey} key={eventKey}>
                      <Accordion.Header>
                        <p className="question_text">{item?.question}</p>

                        <div className="icon_holder">
                          <FontAwesomeIcon
                            icon={
                              activeKey === eventKey ? faAngleUp : faAngleDown
                            }
                            className="icon_text"
                          />
                        </div>
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="answer_div">
                          <p className="faq_answer_text">{item?.answer}</p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </div>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
